// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","orderDetail":"G1cf144","section":"G83921c","openCardSection":"G84cbdf G83921c","openCardSectionNoBorder":"Ga3bd7d G83921c","button":"G8adfdd"};